import moment from 'moment-timezone/builds/moment-timezone-with-data.min.js';

function a(_moment) {
  // https://github.com/SpotOnInc/moment-round/blob/master/src/moment-round.js
  _moment.fn.round = function round(precision, rawKey, direction = 'round') {
    const methods = {
      hours: {
        name: 'Hours',
        maxValue: 24
      },
      minutes: {
        name: 'Minutes',
        maxValue: 60
      },
      seconds: {
        name: 'Seconds',
        maxValue: 60
      },
      milliseconds: {
        name: 'Milliseconds',
        maxValue: 1000
      }
    }

    const keys = {
      mm: methods.milliseconds.name,
      milliseconds: methods.milliseconds.name,
      Milliseconds: methods.milliseconds.name,
      s: methods.seconds.name,
      seconds: methods.seconds.name,
      Seconds: methods.seconds.name,
      m: methods.minutes.name,
      minutes: methods.minutes.name,
      Minutes: methods.minutes.name,
      H: methods.hours.name,
      h: methods.hours.name,
      hours: methods.hours.name,
      Hours: methods.hours.name
    }

    let maxValue
    let value = 0
    let rounded = false
    let subRatio = 1

    const needsPluralized = (k) => k.length > 1 && k !== 'mm' && k.slice(-1) !== 's'
    const key = keys[needsPluralized(rawKey) ? `${rawKey}s` : rawKey].toLowerCase()

    if (!methods[key]) {
      throw new Error(`Invalid method ${key}. Try one of: ${Object.keys(methods).join()}`)
    }

    const get = `get${methods[key].name}`
    const set = `set${methods[key].name}`

    Object.keys(methods).forEach((k) => {
      if (k === key) {
        value = this._d[get]()
        maxValue = methods[k].maxValue
        rounded = true
      } else if (rounded) {
        subRatio *= methods[k].maxValue
        value += this._d[`get${methods[k].name}`]() / subRatio
        this._d[`set${methods[k].name}`](0)
      }
    })

    value = Math[direction](value / precision) * precision
    value = Math.min(value, maxValue)
    this._d[set](value)

    return this
  }

  // precise humanize
  // https://github.com/moment/moment/issues/348#issuecomment-629836811
  _moment.relativeTimeRounding((t) => {
    const DIGITS = 2 // like: 2.56 minutes
    return Math.round(t * Math.pow(10, DIGITS)) / Math.pow(10, DIGITS)
  })
  _moment.relativeTimeThreshold('y', 365)
  _moment.relativeTimeThreshold('M', 12)
  _moment.relativeTimeThreshold('w', 4)
  _moment.relativeTimeThreshold('d', 31)
  _moment.relativeTimeThreshold('h', 24)
  _moment.relativeTimeThreshold('m', 60)
  _moment.relativeTimeThreshold('s', 60)
  _moment.relativeTimeThreshold('ss', 0)
  return _moment
}

export default {
  install(app) {
    const systemTimezone = import.meta.env.VITE_APP_API_SYSTEM_TIMEZONE
    moment.tz.setDefault(systemTimezone)
    console.debug(moment().format()) // should be +9

    // moment = a(moment)
    app.config.globalProperties.$moment = moment;
  },
};
